module.exports = __webpack_public_path__ + "img/modal-close-icon.5e0d24cf.svg";